import { render, staticRenderFns } from "./OrderWhatsDialog.vue?vue&type=template&id=1fd19983"
import script from "./OrderWhatsDialog.vue?vue&type=script&lang=js"
export * from "./OrderWhatsDialog.vue?vue&type=script&lang=js"
import style0 from "./OrderWhatsDialog.vue?vue&type=style&index=0&id=1fd19983&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports